module.exports = __webpack_public_path__ + "img/logo_medium.17ec2efe.png";